import React from 'react';
import DepartmentCard from './DepartmentCard';
import departmentsData from '../data/departmentsData';

function Departments() {
    return (
        <section id="services">
            <p class="anchor" id="serviços"></p>
            <div className="container wow fadeIn">
                <div className="section-header">
                    <h3 className="section-title">Departamentos</h3>
                    <p className="section-description">Breve descrição do modo de funcionamento dos quatro principais departamentos do NEEQ-FEUP</p>
                </div>
                <div className="row">
                    {departmentsData.map((department, index) =>
                        <DepartmentCard
                            key={index}
                            name={department.name}
                            description={department.description}
                            coordinators={department.coordinators}
                            icon={department.icon}
                            delay={department.delay}
                        />
                    )}
                </div>

            </div>
        </section>
    );
}

export default Departments;